export const HEARTBEAT_EN = {
  heartbeat: 'Agent',
  heartbeatDescription: 'Monitor and manage scheduled tasks',
  createMonitor: 'Create Monitor',
  editMonitor: 'Edit Monitor',
  deleteMonitor: 'Delete Monitor',
  monitorName: 'Name',
  monitorDescription: 'Description',
  taskType: 'Task Type',
  taskQuery: 'Task Query',
  taskQueryPlainLanguageHint:
    'Emails default to German and plain language (clear summary, impact, and next steps).',
  modelSelectPlaceholder: 'Select a model',
  modelLoading: 'Loading available models...',
  modelLoadFailed: 'Model list unavailable. Monitor save is disabled until models load.',
  modelFallbackHint:
    'No selectable models found. Monitor save is disabled until a model is available.',
  heartbeatWebSearchEnabled: 'Enable Web Search',
  webSearchEnabledHint: 'When disabled, Agent runs without web grounding.',
  schedulePreset: 'Schedule Preset',
  presetEvery15Minutes: 'Every 15 minutes',
  presetHourly: 'Hourly',
  presetEvery4Hours: 'Every 4 hours',
  presetDaily: 'Daily',
  presetWeekdays: 'Weekdays (Mon-Fri)',
  presetWeekly: 'Weekly',
  presetCustom: 'Custom',
  weeklyDay: 'Weekday',
  weekdayMon: 'Monday',
  weekdayTue: 'Tuesday',
  weekdayWed: 'Wednesday',
  weekdayThu: 'Thursday',
  weekdayFri: 'Friday',
  weekdaySat: 'Saturday',
  weekdaySun: 'Sunday',
  scheduleType: 'Schedule Type',
  intervalMinutes: 'Interval (minutes)',
  cronExpression: 'Cron Expression',
  cronExpressionHint: 'Use 6-part Spring cron format: sec min hour day month weekday.',
  timeOfDay: 'Time of Day',
  timezone: 'Timezone',
  outputChannel: 'Delivery Channel',
  outputTargetEmail: 'Delivery Email',
  outputTargetEmailHint: 'Agent results are sent to your account email.',
  outputTargetEmailUnavailable:
    'No account email found. Add an account email to enable monitor save.',
  outputTargetEmailInvalid: 'Please enter a valid email address.',
  enabled: 'Enabled',
  paused: 'Paused',
  active: 'Active',
  currentlyExecuting: 'Currently executing',
  lastExecution: 'Last Execution',
  nextScheduled: 'Next Scheduled',
  nextRunNow: 'Next run now',
  nextRunInMinutes: 'Next run in {count} min',
  nextRunInHours: 'Next run in {count} hour(s)',
  nextRunInDays: 'Next run in {count} day(s)',
  executeNow: 'Execute Now',
  pauseMonitor: 'Pause',
  resumeMonitor: 'Resume',
  noMonitors: 'No agents yet',
  noMonitorsDescription: 'Create an agent to start tracking scheduled tasks',
  searchMonitors: 'Search agents...',
  noMonitorsFound: 'No agents found',
  clearSearch: 'Clear search',
  confirmDeleteMessage:
    'Are you sure you want to delete this monitor? This action cannot be undone.',
  monitorCreated: 'Monitor created successfully',
  monitorUpdated: 'Monitor updated successfully',
  monitorDeleted: 'Monitor deleted successfully',
  monitorPaused: 'Monitor paused',
  monitorResumed: 'Monitor resumed',
  executionTriggered: 'Execution triggered',
  research: 'Research',
  geo: 'Geo',
  generation: 'Generation',
  interval: 'Interval',
  cron: 'Cron',
  dailyAt: 'Daily at',
  everyNMinutes: 'Every {count} min',
  cancel: 'Cancel',
  create: 'Create',
  executionHistory: 'Execution History',
  executionResult: 'Execution Result',
  noExecutions: 'No executions yet',
  noExecutionsDescription: 'This monitor has not been executed yet',
  executionRun: 'Run {count}',
  resultPreviewUnavailable: 'No inline result preview. Open the run for full output.',
  viewFullResult: 'View full result',
  executionDetails: 'Execution Details',
  executionStatus: 'Status',
  statusStart: 'Started',
  statusSent: 'Sent',
  statusStep: 'Step',
  statusRunning: 'Running',
  statusInProgress: 'In progress',
  statusPending: 'Pending',
  statusFinished: 'Finished',
  statusDone: 'Done',
  statusCompleted: 'Completed',
  statusSuccess: 'Success',
  statusSucceeded: 'Succeeded',
  statusError: 'Error',
  statusFailed: 'Failed',
  statusFailure: 'Failure',
  statusNeverRun: 'Never run',
  statusQueued: 'Queued',
  statusCancelled: 'Cancelled',
  statusTimeout: 'Timeout',
  statusSkipped: 'Skipped',
  statusDelivered: 'Delivered',
  executionTrigger: 'Trigger',
  executionStart: 'Started',
  executionEnd: 'Ended',
  resultTab: 'Result',
  addResultToEditor: 'Add to Editor',
  sourcesTab: 'Sources',
  statsTab: 'Stats',
  resultUnavailable: 'No result available for this execution.',
  sourcesUnavailable: 'No sources available for this execution.',
  resultTruncated: '[Result truncated for readability]',
  citationCount: 'Source Count',
  deliveryStatus: 'Delivery Status',
  deliveryTime: 'Delivery Time',
  deliveryError: 'Delivery Error',
  notAvailable: 'Not available',
  changeSummary: 'Change Summary',
  citations: 'Citations',
  errorMessage: 'Error',
  scheduled: 'Scheduled',
  manual: 'Manual',
  backToMonitors: 'Back to monitors',
  viewExecutions: 'View Executions',
  totalCost: 'Total Cost'
}
